import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { User } from '../_models';
import { UserService } from '../_services';

@Injectable()
export class UserResolver implements Resolve<User[]> {
  constructor(private userService: UserService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<User[]> {
    const id = route.paramMap.get('id');
    if (id) {
      if (isNaN(+id)) {
        this.router.navigate(['']);
        return EMPTY;
      }

      return this.getUserById(+id);
    } else {
      return this.getAllUsers();
    }
  }

  getUserById(id: number): Observable<User[]> {
    return this.userService.getById(id).pipe(
      switchMap((user) => {
        if (user) {
          return of([user]);
        }
        this.router.navigate(['']);
        return EMPTY;
      })
    );
  }

  getAllUsers(): Observable<User[]> {
    return this.userService.getAll();
  }
}
